export enum TypeDocumentEnum {
  Cpf,
  Cnpj,
}
